// extracted by mini-css-extract-plugin
export default {"container":"modal__container___3mgMw","isOpen":"modal__isOpen___VIBVy","inner":"modal__inner___2vm4W","title":"modal__title___2dpp3","content":"modal__content___ubbBh"};